module.exports = __webpack_public_path__ + "img/202405_08.7b6a1771.jpg";